import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../lib/auth';

// The Twitch OAuth flow lands on /api/auth/twitch/callback (a Pages Function),
// which sets the session cookie and 302s to this route with ?return_to=...
// We just refresh /api/me and navigate the user where they wanted to go.
export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useAuth();

  useEffect(() => {
    const returnTo = params.get('return_to') || '/account';
    void refresh().finally(() => {
      navigate(returnTo, { replace: true });
    });
  }, [navigate, params, refresh]);

  return <p className="text-center text-textSecondary py-12">Signing you in…</p>;
}
